const MESSAGES = {
  // WEBSITES
  ENTER_WEBSITE_TITLE: 'عنوان وب سايت را وارد نماييد',
  ENTER_WEBSITE_ADDRESS: 'آدرس وب سايت را وارد نماييد',
  INVALID_WEBSITE_ADDRESS: 'آدرس وب سايت نامعتبر است',

  // Black list
  ALL_BLOCKED_REMOVED: 'همه كاربران بلوكه شده از ليست سياه حذف شدند.',

  // convs archive
  CONVS_ARCHIVE_OPEN_CONV_SUCCESS:
    'مکالمه با موفقیت به شما اختصاص یافت، مکالمه را میتوانید از اپلیکیشن تحت وب ادامه بدهید',
  CONVS_ARCHIVE_ALREADY_ASSIGNED: 'مکالمه از قبل به شما اختصاص یافته است',
  CONVS_ARCHIVE_INFO_SAVED: 'اطلاعات کاربر با موفقیت ذخیره شد',
  CONVS_ARCHIVE_EMAIL_WHEN_READY:
    'به محض آماده شدن فایل خروجی آن را برای شما ایمیل میکنیم!',
  CONVS_ARCHIVE_EXPORT_LIMIT:
    'روزانه فقط دوبار قادر به دریافت فایل خروجی میباشید!',

  // Departments
  PROBLEM_CREATING_TEAM:
    'در هنگام ايجاد تیم خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  TEAM_CREATE_SUCCESS: 'تیم با موفقیت ایجاد شد',
  PROBLEM_EDITING_TEAM:
    'در هنگام ویرایش تیم خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  PROBLEM_REMOVING_TEAM:
    'در هنگام حذف تیم خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  SUCCESSFUL_REMOVING_TEAM: 'حذف تیم با موفقیت انجام شد',

  // faq
  FAQ_SUCCESSFUL_ADDED: 'سوال متداول با موفقیت ایجاد شد',
  QUESTION_SUCCESSFUL_ADDED: 'سوال با موفقیت ایجاد شد',
  SORT_REORDER_SUCCESSFUL: 'جابه‌جایی با موفقیت انجام شد',
  PROBLEM_REORDER: 'در هنگام جابه‌جایی مشکلی به وجود آمده است',
  QUESTION_REMOVED: 'سوال حذف شد',
  FAQ_REMOVED: 'دسته بندی مورد نظر حذف شد!',

  // operators
  NEW_OPERATOR_SUCCESS_INVITE: 'اپراتور جديد با موفقيت دعوت شد.',
  OPERATOR_CHANGES_SUCCESSFUL: 'تغييرات اپراتور با موفقيت ذخيره شد.',
  MOBILE_REGISTERED_BEFORE: 'این شماره موبایل قبلا ثبت شده است.',

  // apps list
  REQUEST_ADD_APP_SUCCESS: 'برنامه شما با موفقیت افزوده شد!',
  REQUEST_DELETE_APP_SUCCESS: 'برنامه شما با موفقیت حذف شد!',

  // two-step verification
  SEND_CODE_REQUEST_EMAIL: 'کد تایید با موفقیت به ایمیل شما ارسال شد!',
  SEND_CODE_REQUEST_PHONE: 'کد تایید با موفقیت به شماره شما ارسال شد!',

  // settings
  SETTINGS_SUCCESSFUL_SAVED: 'تنظیمات مورد نظر ذخیره شد',
  AUTO_MSG_ADDED: 'پیام ایجاد شد',
  AUTO_MSG_DELETED: 'پیام حذف شد',
  AUTO_MSG_SENDER_CHANGES: 'فرستنده پیام تغییر کرد',
  AUTO_MSG_LEAST_CONDITION: 'ایجاد حداقل یک شرط الزامیست',
  AUTO_MSG_COMPLETE_CONDITION: 'انتخاب شرط را کامل کنید',
  ADDRESS_INVALID: 'آدرس صفحه معتبر نمی باشد !',
  AUTO_MSG_EDITOR_MAX_CHAR: 'تعداد کاراکتر مجاز نیست',
  WIDGET_AT_LEAST_ONE_ADDRESS: 'حداقل باید یک آدرس اضافه کنید !',

  // user
  FOUR_DIGIT_CODE_SENT_BY_SMS: 'كد 4 رقمی از طريق پيامك ارسال گرديد',
  PROBLEM_SENDING_CODE_BY_SMS:
    'کد برای شما ارسال شده است ،‌ برای دریافت مجدد لطفا بعد از ۲ دقیقه مجدد تلاش کنید.',
  EMAIL_ALREADY_USED: '.ايميل قبلا ثبت شده است. ايميل ديگری را وارد كنيد',
  PHONE_NUM_ALREADY_USED: 'موبايل قبلا ثبت شده است. موبايل ديگری را وارد كنيد.',
  PROBLEM_WHILE_SIGNING_UP:
    'ثبت نام با مشكل مواجه شده است. لطفا دوباره تلاش كنيد.',
  PASSWORD_IS_NOT_CORRECT: 'رمز عبور اشتباه است.',
  DONT_HAVE_ACCESS_TO_THIS_SECTION:
    'کاربر گرامی شما دسترسی ورود به این قسمت را ندارید. لطفا ایمیل دیگری را وارد کنید و یا از "بخش گفتگو با کاربران" وارد شوید.',
  DONT_HAVE_ACCESS_ADMIN_PANEL:
    'شما اجازه دسترسی به داشبورد مديريتی را نداريد. ',
  RESET_PASS_EMAIL_SENT:
    'ايميل بازيابی ارسال شد. لطفا با رمز عبور ارسال شده به ايميل تان وارد شويد.',
  NO_ACCOUNT_WITH_THIS_EMAIL:
    'حساب كاربری با اين ايميل ثبت نشده است. لطفا ايميل ديگری را وارد كنيد.',

  // payments
  ENTERED_CODE_IS_WRONG: 'كد وارد شده اشتباه است.',
  DISCOUNT_JUST_FOR_FIRST_FACTOR:
    'این تخفیف فقط برای اولین فاکتور قابل اعمال است !',
  CANT_DOWNGRADE_PACKAGE: 'ارتقا به پکیج پایین تر امکان پذیر نیست.',
  PROBLEM_WHILE_MAKING_INVOICE:
    'در ايجاد فاكتور خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  ENTERED_CODE_WRONG_TRY_AGAIN:
    'كد وارد شده اشتباه است. لطفا دوباره تلاش كنيد.',

  // webhook
  NEW_WEBHOOK_ADDED: 'وب هوک جدید با موفقیت ایجاد شد',

  // websites
  SITE_REGISTERED_BEFORE:
    'اين سايت قبلا ثبت شده است. لطفا آدرس سايت ديگری را وارد كنيد.',
  BARCODE_SCANNED_BEFORE: 'این بارکد قبلا اسکن شده است.لطفا مجددا تلاش کنید.',
  WEBSITE_ADDED_SUCCESS: 'وب سايت با موفقيت اضافه شد.',
  WEBSITE_NUM_MAX_ERROR: 'شما مجاز نيستيد بيشتر از 5 وب سايت اضافه كنيد.',
  SITE_ALREADY_REGISTERED_IN_ANOTHER_ACCOUNT:
    'این سایت قبلا در اکانت دیگری ثبت شده. لطفا سایت دیگری را امتحان کنید',
  WEBSITE_ENABLE: 'وب سايت فعال شد.',
  WEBSITE_DISABLED: 'وب سايت غيرفعال شد.',
  PROBLEM_ASSIGNING_OPERATOR:
    'در تخصيص اپراتور خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  SELECTED_OPERATORS_ASSIGNED: 'اپراتور های انتخاب شده تخصيص يافت.',
  MESSAGE_SENT: 'پیام با موفقیت ارسال شد',
  MAX_GROUP_MSG_LIMIT_REACHED:
    'شما حداکثر تعداد پیام گروهی امروز خود را ارسال نموده‌اید',
  WEBSITE_NOT_CONNECTED_WHATSAPP: 'وبسایت مورد نظر به واتساپ متصل نشده است',

  // mutual
  UPLOAD_IMAGE_NOT_SUCCESSFUL: 'آپلود تصویر با مشکل مواجه شد. دوباره تلاش کنید',
  FILL_EMPTY_FIELDS: 'لطفا فیلد‌های خالی را پر کنید',
  CHANGES_SAVED: 'تغییرات ذخیره شد',
  SUCCESSFULL_EDITING: 'ویرایش با موفقیت انجام شد',
  SUCCESSFUL_UPDATING_INFO: 'به روزرسانی اطلاعات با موفقیت انجام شد',
  PROBLEM_UPDATING_INFO_TRY_AGAIN:
    'در هنگام به روزرسانی اطلاعات خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  CORRECT_ERRORS: 'لطفا خطاها را تصحیح کنید',
  PROBLEM_IN_PROCESS:
    'در عملیات مورد نظر خطايی رخ داده است. لطفا دوباره تلاش كنيد.',
  CHAR_LENGTH_EXCEED: 'تعداد کاراکتر بیش از حد مجاز',
  FIELD_CANNOT_EMPTY: 'این فیلد نمیتواند خالی باشد',
  REQUEST_SUBMITED_SUCCESS: 'درخواست شما با موفقیت ثبت شد !',
  INFO_SAVED_SUCCESS: 'اطلاعات شما با موفقیت ذخیره شد!',
  FILL_ALL_FIELDS: 'پر کردن تمامی فیلدها الزامی می‌باشد!',
  UPGRADE_TO_USE_FEATURE: 'برای استفاده از این ویژگی پکیج خودرا ارتقاء دهید.',
  EXPIRE_BANNER_ENDED_CREDIT:
    'اعتبار پکیج شما به پایان رسیده است. لطفا برای تمدید آن اقدام نمایید.',

  // validations
  ENTER_EMAIL: 'ايميل را وارد نماييد',
  EMAIL_INVALID: 'ایمیل نامعتبر است',
  ENTER_PASSWORD: 'رمز عبور را وارد نماييد',
  ENTER_TITLE: 'عنوان را وارد نمایید',
  ENTER_NAME: 'نام كامل را وارد نماييد',
  NAME_CHAR_ERROR: 'نام بايد بيش از دو حرف باشد',
  NAME_INVALID_ERROR: 'نام نبايد شامل اعداد و فاصله ی آخر باشد',
  ENTER_MOBILE: 'موبايل را وارد نماييد',
  INVALID_MOBILE: 'موبايل نامعتبر است',
  PASSWORD_LENGTH_INVALID: 'رمز عبور باید بیش از 8 حرف یا عدد باشد',
  PASSWORD_INVALID_CHARS: 'رمز عبور بايد شامل حروف كوچک و بزرگ و اعداد باشد',
  PASSWORD_REPETITION_NOT_VALID: 'تكرار رمزعبور با رمزعبور مطابقت ندارد',
  TITL_AND_NAME_SHOULDNT_EQUAL: 'عنوان و نام کامل نباید برابر باشند.',
  INVALID_FILE_FORMAT: 'فرمت فایل مجاز نمیباشد',
  IMAGE_SIZE_EXCEED: 'حجم تصویر بیش از 500 کیلوبایت است',

  // signup validation
  SIGNUP_ENTER_NAME: 'نام را وارد نماييد',
  SIGNUP_NAME_LENGTH: 'نام بايد بيش از يک حرف باشد',
  SIGNUP_NAME_INVALID: 'نام نبايد شامل اعداد باشد',
  ENTER_LASTNAME: 'نام خانوادگی را وارد نماييد',
  SIGNUP_LASTNAME_LENGTH: 'نام خانوادگی بايد بيش از يک حرف باشد',
  SIGNUP_LASTNAME_INVALID: 'نام خانوادگی نبايد شامل اعداد باشد',

  // handleErrors
  SERVER_ERROR: 'ارتباط با سرور با مشكل مواجه شده است.',
  UPGRADE_PACKAGE: 'برای ادامه دسترسی پکیج خود را ارتقا دهید',
  SERVER_ERROR_TRY_AGAIN: 'خطايی در سرور رخ داده است. لطفا دوباره تلاش كنيد.',
  INVALID_ACCESS_LEVEL: 'سطح دسترسی غير مجاز می باشد.',
  CONTENT_NOT_FOUND: 'محتوايی برای درخواست شما يافت نشد.',
  SENT_REQUEST_NOT_CORRECT: 'درخواست ارسال شده صحيح نيست.',
  TOO_MANY_REQUESTS: 'محدودیت تعداد درخواست! لطفا مدتی بعد دوباره تلاش کنید',

  // Copy to clipboard
  COPY_CODE_CLIPBOARD_ERROR:
    'كپی تكه كد با خطا مواجه شده است، لطفا دوباره تلاش كنيد.',
  COPY_CODE_CLIPBOARD_SUCCESS: 'تكه كد كپی شد',

  // complete info validation error
  COMPANY_NAME: 'نام كامل شركت را وارد نماييد',
  COMPANY_NATIONAL_NUMBER: 'شناسه ملی شركت را وارد نماييد',
  COMPANY_INVALID_NATIONAL: 'شناسه ملی شركت نامعتبر است',
  COMPANY_ECONOMIC: 'كد اقتصادی شركت را وارد نماييد',
  COMPANY_REGISTER: 'شماره ثبت شركت را وارد نماييد',
  COMPANY_ADDRESS: 'آدرس شركت را وارد نماييد',

  ENTER_NATIONAL_ID_NUMBER: 'كد ملی را وارد نماييد',
  INVALID_NATIONAL_ID_NUMBER: 'كد ملی نامعتبر است',

  ENTER_PHONE: 'تلفن ثابت را وارد نماييد',
  INVALID_PHONE: 'تلفن ثابت نامعتبر است',
  ENTER_PROVINCE: 'استان را وارد نماييد',
  ENTER_CITY: 'شهر را وارد نماييد',
  ENTER_POSTAL_CODE: 'كدپستی محل سكونت را وارد نماييد',
  INVALID_POSTAL_CODE: 'كدپستی نامعتبر است',
  ENTER_RESIDENCE_ADDRESS: 'آدرس محل سكونت را وارد نماييد',

  ONE_TIME_CODE_IS_INCORRECT: 'کد وارد شده صحیح نیست!',
  // RESPONSE DELAY
  RESPONSE_DELAY_FORM_TYPE_ERROR:
    'لطفا مقدار تمامی فیلد ها را به درستی وارد کنید!',
  RESPONSE_DELAY_FORM_ERROR: 'مقدار فرم اضافه شده خالی می‌باشد!',
  RESPONSE_DELAY_FORM_SUBMIT: 'عملیات تاخیر با موفقیت ایجاد شد.',
  RESPONSE_DELAY_CONDITION: 'عملیات تاخیر با موفقیت اصلاح شد.',
  RESPONSE_DELAY_CONDITION_DELETE: 'عملیات تاخیر با موفقیت حذف شد.',
  RESPONSE_DELAY_IN_CONVERSATION_COUNT_ERROR:
    'تعداد عملیات های درحال مکالمه به حداکثر تعداد مجاز (3) رسیده است!',
  RESPONSE_DELAY_IN_COMING_COUNT_ERROR:
    'تعداد عملیات های در انتظار پاسخ به حداکثر تعداد مجاز (3) رسیده است!',
  RESPONSE_DELAY_ALL_DEPARTMENTS_COUNT_ERROR:
    'تعداد عملیات های تعریف شده برای تمامی دپارتمان ها به حداکثر تعداد مجاز (3) رسیده است!',
  RESPONSE_DELAY_DEPARTMENT_SELECTED_COUNT_ERROR:
    'تعداد عملیات تعریف شده برای دپارتمان انتخابی به حداکثر تعداد مجاز (3) رسیده است!',

  // FORM GENERATOR
  FORM_GENERATOR_SUBMIT: 'فرم درخواستی با موفقیت ایجاد شد.',
  ONLY_PERSIAN_CHARS_VALID: 'تنها کاراکترهای فارسی مجاز میباشند',
  PERSIAN_ADDRESS_INVALID:
    'تنها کاراکترهای فارسی،فاصله، اعداد و خط تیره مجاز میباشند',

  PACKAGE_EXPIRE_SOON_BANNER_TEXT:
    'از اعتبار پکیج شما تنها #days# روز باقی مانده است. لطفا برای تمدید پکیج اقدام نمایید.',
  REMAINING_CONVS_ENDING_BANNER_TEXT:
    'از مکالمات شما تنها #convs# عدد باقی مانده است. لطفا نسبت به شارژ آن اقدام نمایید.',
  REMAINING_CONVS_ENDED_BANNER_TEXT:
    'مکالمات باقی مانده حساب شما به اتمام رسیده است. لطفا نسبت به شارژ آن اقدام نمایید',

  // KNOWLEDGE BASE
  KNOWLEDGE_BASE_SEND_DATA: 'اطلاعات با موفقیت ارسال شد.',
  KNOWLEDGE_BASE_GET_DATA: 'اطلاعات با موفقیت دریافت شد.',
  KNOWLEDGE_BASE_LINK_COPIED: 'لینک پایگاه دانش شما با موفقیت کپی شد!',

  FORM_GENERATOR_FORM_ERROR: 'مقدار فرم اضافه شده خالی می‌باشد!',
  FORM_GENERATOR_FORM_EMPTY_ERROR: 'فرمی ایجاد نشده است!',

  // RESPONSIVE ROBOT
  RESPONSIVE_ROBOT_OPERATION_DELETE: 'عملیات مورد نظر با موفقیت حذف شد.',
  RESPONSIVE_ROBOT_OPERATION_UPDATE: 'عملیات مورد نظر با موفقیت اصلاح شد.',
  RESPONSIVE_ROBOT_SUBMIT: 'عملیات مورد نظر با موفقیت ایجاد شد.',
  RESPONSIVE_ROBOT_FORM_ERROR: 'پر کردن تمامی فیلد ها الزامی می‌باشد!',
  ENTER_BIRTH_DATE: 'تاریخ تولد را وارد کنید',

  LARGE_FILE_UPLOADED: 'لوگو بارگزاری شده بزرگتر از حد مجاز می‌باشد!',

  // USER vISITS ARCHIVE
  REQUEST_ADD_FILTER_SUCCESS: 'فیلتر های انتخاب شده با موفقیت اعمال شد.',
  REQUEST_ADD_FILTER_FAILURE: 'مشکلی در اعمال فیلتر ها پیش آمده است!',
  REQUEST_ADD_FILTER_CHANNEL_ID_FAILURE:
    'مشکلی در اعمال فیلتر ها پیش آمده است، لطفا لحظاتی دیگر دوباره تلاش کنید!',
  REQUEST_EXPORT_USER_VISITS_SUCCESS:
    'به محض آماده شدن فایل خروجی آن را برای شما ایمیل میکنیم!',
  REQUEST_EXPORT_USER_VISITS_FAILURE:
    'مشکلی در ایجاد درخواست فایل خروجی به وجود آمده است!',

  DELETE_WEBSITE: 'وبسایت موردنظر با موفقیت حذف شد',

  UPGRADE_TO_ADD_NEW_WEBSITE: 'برای افزودن وبسایت جدید پکیج خود را ارتقا دهید',
};

export default MESSAGES;
